const initMarqueeSlider=(e,t={})=>{const n=document.getElementById(e),a=n.querySelector(".marquee-slider-wrapper"),s=a.getElementsByClassName("marquee-slider-slides-wrapper"),i=e=>"right"===e?{sym:"+",axis:"X"}:"left"===e?{sym:"-",axis:"X"}:"up"===e?{sym:"-",axis:"Y"}:"down"===e?{sym:"+",axis:"Y"}:void 0,{stopOnHover:r=!1,allowPointEvent:l=!0,dir:o="left"}=t;l||(n.style.pointerEvents="none");const d=parseFloat(n.getAttribute("data-speed"))||5,m=parseFloat(n.getAttribute("data-space"))||10,p=n.getAttribute("data-prefix")||"px",y=m,f=p,c=a.cloneNode(!0),u=t=>{const a=s[0].offsetWidth;s[0].offsetHeight;"right"===o&&(t.style.left=`-${a+m}px`);const l=`\n       @keyframes ${e} {\n         0% {\n           transform: translate${i(o).axis}(0);\n         }\n         100% {\n           transform: translate${i(o).axis}(${i(o).sym}${a+m}px);\n         }\n       }\n       \n     `;let p=Math.ceil(n.offsetWidth/a);p<1&&(p=1);let y=s.length;for(let e=1;e<=p;e++)for(let e=0;e<y;e++){const n=s[e].cloneNode(!0);t.appendChild(n)}t.style.animation=`${e} ${d}s linear infinite`;const f=document.createElement("style");f.innerHTML=l,document.head.appendChild(f),t.addEventListener("animationiteration",(()=>{t.style.transform=`translate${i(o).axis}(0)`})),r&&(t.addEventListener("mouseleave",(()=>{t.style.animationPlayState="running"})),t.addEventListener("mouseenter",(()=>{t.style.animationPlayState="paused"})))};n.style.overflow="hidden",s[0].style.gap=`0 ${y}${f}`,s[0].style.margin=`0 ${y/2}${f}`,s[0].style.minWidth=`${s[0].offsetWidth}px`,u(a),window.addEventListener("resize",u(c))};


$(document).ready(function(){
  $('.quantity__input[name="quantity"]').bind('change', function(e) {
    var newQuantity = $(this).val();
    $('#meter-notice').html(newQuantity + ' entspricht ' + (newQuantity / 2.0).toLocaleString() + ' Meter');
  })
  
  $('.unit-price').each(function(i) {
    var span = $(this).find('span').slice(-1);
    var txt = $(span).text();
    console.log(txt.trim());
    if (txt.trim() == 'm') {
      $(span).text('Meter');
    }
  });

  //initMarqueeSlider("marquee-slider-announcement-bar", {stopOnHover:true, allowPointEvent:true, dir:'left'});

  $('.swipeslider > ul').each(function(i) {
    var mobileSlides = 1;
    var tabletSlides = 1;
    var desktopSlides = 1;
    var autoPlay = false;
    var autoPlaySpeed = 2000;
    var centerMode = false;
    var centerPadding = "60px";
    var self = this;
    if ($(this).parent().attr('swipeslider-desktop')) {
      desktopSlides = parseInt($(this).parent().attr('swipeslider-desktop'));
    }
    if ($(this).parent().attr('swipeslider-mobile')) {
      mobileSlides = parseInt($(this).parent().attr('swipeslider-mobile'));
    }
    if ($(this).parent().attr('swipeslider-tablet')) {
      tabletSlides = parseInt($(this).parent().attr('swipeslider-tablet'));
    }
    if ($(this).parent().attr('swipeslider-autoplay')) {
      autoPlay = $(this).parent().attr('swipeslider-autoplay') === "true";
    }
    if ($(this).parent().attr('swipeslider-autoplayspeed')) {
      autoPlaySpeed = parseInt($(this).parent().attr('swipeslider-autoplayspeed'));
    }
    if ($(this).parent().attr('swipeslider-centermode')) {
      centerMode = $(this).parent().attr('swipeslider-centermode') === "true";
    }
    if ($(this).parent().attr('swipeslider-centerpadding')) {
      centerPadding = $(this).parent().attr('swipeslider-centerpadding');
    }

    $(this).find('li').removeClass('grid__item');
    $(this).removeClass('grid').removeClass('grid--1-col').removeClass('grid--4-col-tablet').removeClass('grid--quarter-max');

    var params = {
        slidesToShow: desktopSlides,
        slidesToScroll: desktopSlides,
        autoplay: autoPlay,
        autoplaySpeed: autoPlaySpeed,
        centerMode: centerMode,
        centerPadding: centerPadding,
        lazyLoad: 'progressive',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: tabletSlides,
              slidesToScroll: tabletSlides,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: mobileSlides,
              slidesToScroll: mobileSlides,
            }
          }
        ]
      };
    
    
    var self = this;
    window.setTimeout(function() {
      $(self).slick(params);

      window.setTimeout(function() {
        $(self).slick('refresh');
        $(self).parent().addClass('swipesliderleftrightoverlay');
        // find biggest slide
        var height = 0;
        $(self).find('li.slick-slide').each(function(i, obj) {
          if ($(obj).height() > height) {
            height = $(obj).height();
          }
        });
        $(self).parent().css('max-height', height + 'px');
      }, 1000);
    });
    
  });
});